import { BaseDto } from './base.dto';

export class PaymentSourceDto extends BaseDto {
  code: string;
  table: string;
  description: string;
  conditions?: string;
}
